import { render } from "./Game.vue?vue&type=template&id=1ee45b58"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=1ee45b58&scss=true&lang=css"

import exportComponent from "E:\\幻灵格斗\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__